import PDFBuilder, { fmtDate, fmtDateFromISO } from "../../utils/pdfBuilder.js";

const tipImobilLabels = {
  apartament: "apartamentul",
  casa: "casa",
  spatiu_comercial: "spatiul comercial",
};

export default function buildComodatPDF(data, filename) {
  const pdf = new PDFBuilder();
  const today = fmtDate(new Date());

  const tipImobilText = data.imobilTip === "altul"
    ? (data.imobilTipAltul || "imobilul")
    : (tipImobilLabels[data.imobilTip] || "imobilul");
  const ascundeCamere = data.imobilTip === "spatiu_comercial" || data.imobilTip === "altul";

  const durateLuni = parseInt(data.durata) || 12;
  const dataInceputFmt = data.dataInceput ? fmtDateFromISO(data.dataInceput) : "___";
  let dataEndFmt = "___";
  if (data.dataInceput) {
    const end = new Date(data.dataInceput);
    end.setMonth(end.getMonth() + durateLuni);
    dataEndFmt = fmtDate(end);
  }

  // Header
  pdf.title("Contract de Comodat", "(folosinta gratuita)");

  // I. PARTILE CONTRACTANTE
  pdf.section("I. PARTILE CONTRACTANTE");

  pdf.pMixed([{ text: "1.1. Comodantul:", bold: true }]);
  pdf.renderPartyPFPJ(data, "comodant", data.comodantPJ);

  pdf.italic("si");

  pdf.pMixed([{ text: "1.2. Comodatarul:", bold: true }]);
  pdf.renderPartyPFPJ(data, "comodatar", data.comodatarPJ);

  pdf.intro("au convenit incheierea prezentului contract de comodat, in conformitate cu dispozitiile art. 2146-2157 din Codul Civil, in urmatoarele conditii:");

  // II. OBIECTUL CONTRACTULUI
  pdf.section("II. OBIECTUL CONTRACTULUI");

  const camereText = !ascundeCamere && data.imobilCamere ? `, compus din ${data.imobilCamere} camere` : "";
  const etajText = data.imobilEtaj ? `, etajul ${data.imobilEtaj}` : "";
  pdf.pMixed([
    { text: "2.1. ", bold: true },
    { text: "Comodantul transmite Comodatarului, cu titlu gratuit, dreptul de folosinta asupra imobilului de tip " },
    { text: tipImobilText, bold: true },
    { text: ` situat in ${data.imobilAdresa || "____________________________"}${camereText}, cu suprafata utila de ${data.imobilSuprafata || "___"} mp${etajText}.` },
  ]);

  pdf.pMixed([
    { text: "2.2. ", bold: true },
    { text: `Imobilul se preda ${data.mobilat ? "mobilat si utilat" : "nemobilat"}, in stare corespunzatoare de folosinta. Predarea imobilului se face pe baza de proces-verbal de predare-primire, care constituie anexa la prezentul contract.` },
  ]);

  pdf.article("2.3.", "Prezentul contract este cu titlu gratuit, Comodatarul neavand obligatia de a plati chirie sau orice alta contraprestatie pentru folosinta imobilului.");

  // III. DESTINATIA IMOBILULUI
  pdf.section("III. DESTINATIA IMOBILULUI");

  pdf.article("3.1.", "Imobilul va fi folosit exclusiv ca locuinta. Este interzisa desfasurarea de activitati comerciale sau inregistrarea de sedii sociale fara acordul scris al Comodantului.");

  pdf.pMixed([
    { text: "3.2. ", bold: true },
    { text: "Numarul maxim de persoane care pot locui in imobil este de " },
    { text: `${data.nrMaxPersoane || "___"}`, bold: true },
    { text: " persoane." },
  ]);

  // IV. DURATA CONTRACTULUI
  pdf.section("IV. DURATA CONTRACTULUI");

  pdf.pMixed([
    { text: "4.1. ", bold: true },
    { text: "Contractul se incheie pe durata de " },
    { text: `${durateLuni} luni`, bold: true },
    { text: ", incepand cu data de " },
    { text: dataInceputFmt, bold: true },
    { text: " si pana la data de " },
    { text: dataEndFmt, bold: true },
    { text: "." },
  ]);

  pdf.pMixed([
    { text: "4.2. ", bold: true },
    { text: `Prelungirea se poate face doar prin acord scris (act aditional), cu minimum ${data.notificareZile || "30"} zile inainte de expirare.` },
  ]);

  // V. OBLIGATIILE COMODANTULUI
  pdf.section("V. OBLIGATIILE COMODANTULUI");

  const obligatiiComodant = [
    "Sa predea imobilul in stare corespunzatoare de folosinta.",
    "Sa asigure Comodatarului folosinta linistita si utila a imobilului pe toata durata contractului.",
    "Sa efectueze reparatiile majore si structurale ale imobilului.",
    "Sa nu tulbure folosinta Comodatarului, cu exceptia verificarilor efectuate cu preaviz de minimum 24 ore.",
    "Sa informeze Comodatarul despre orice vicii ascunse ale imobilului pe care le cunoaste.",
  ];
  obligatiiComodant.forEach((text, i) => {
    pdf.pMixed([
      { text: `5.${i + 1}. `, bold: true },
      { text },
    ], { indent: 5 });
  });

  // VI. OBLIGATIILE COMODATARULUI
  pdf.section("VI. OBLIGATIILE COMODATARULUI");

  const obligatiiComodatar = [
    "Sa conserve imobilul ca un bun proprietar si sa il foloseasca conform destinatiei stabilite.",
    "Sa foloseasca imobilul cu prudenta si diligenta, ca si cum ar fi propriul sau bun.",
    "Sa nu aduca modificari imobilului fara acordul scris al Comodantului.",
    "Sa permita accesul Comodantului pentru verificari, cu preaviz de 24 ore.",
    "Sa anunte imediat Comodantul despre orice defectiune sau deteriorare aparuta.",
    "Sa efectueze reparatiile minore si de intretinere curenta, pe cheltuiala proprie.",
    "Sa restituie imobilul la incetarea contractului, liber de persoane si bunuri, in starea in care l-a primit, mai putin uzura normala.",
  ];
  obligatiiComodatar.forEach((text, i) => {
    pdf.pMixed([
      { text: `6.${i + 1}. `, bold: true },
      { text },
    ], { indent: 5 });
  });

  // 6.8 - subcomodare
  pdf.pMixed([
    { text: "6.8. ", bold: true },
    { text: !data.subcomodarePermisa
      ? "Comodatarul nu are drept de subcomodat, subinchiriere sau cedare a folosintei imobilului sub orice forma, fara acordul scris al Comodantului, sub sanctiunea rezilierii de drept a contractului."
      : "Comodatarul poate permite tertilor sa foloseasca imobilul fara acordul prealabil al Comodantului." },
  ], { indent: 5 });

  // 6.9 - interdictii
  const interdictii = [];
  if (!data.fumatPermis) interdictii.push("fumatul in interior");
  if (!data.animalePermise) interdictii.push("detinerea de animale (fara acord scris)");
  interdictii.push("schimbarea incuietorilor fara acord");

  pdf.pMixed([
    { text: "6.9. ", bold: true },
    { text: "Este interzis:" },
  ], { indent: 5 });
  interdictii.forEach((text) => {
    pdf.p(`- ${text}`, { indent: 8 });
  });

  // VII. CHELTUIELI SI UTILITATI
  pdf.section("VII. CHELTUIELI SI UTILITATI");

  if (data.utilitatiComodatar) {
    pdf.article("7.1.", "Comodatarul suporta integral cheltuielile de folosinta curenta ale imobilului: energie electrica, apa, gaz, internet, salubritate, intretinere si orice alte utilitati.");
    pdf.article("7.2.", "Facturile vor fi achitate de Comodatar la termenele prevazute de furnizorii de utilitati.");
    pdf.article("7.3.", "Impozitul pe proprietate si asigurarea imobilului raman in sarcina Comodantului, cu exceptia utilitatilor curente suportate de Comodatar conform art. 7.1.");
  } else {
    pdf.article("7.1.", "Cheltuielile de folosinta curenta (utilitati, intretinere) sunt suportate de Comodant.");
    pdf.article("7.2.", "Impozitul pe proprietate si asigurarea imobilului raman in sarcina Comodantului.");
  }

  // VIII. INCETAREA CONTRACTULUI
  pdf.section("VIII. INCETAREA CONTRACTULUI");

  pdf.article("8.1.", "Contractul inceteaza:");
  pdf.letterItem("a", "la expirarea duratei");
  pdf.letterItem("b", "prin acordul scris al partilor");
  pdf.letterItem("c", "prin reziliere de plin drept, fara interventia instantei, in cazul neexecutarii obligatiilor esentiale de catre una dintre parti");
  pdf.letterItem("d", `prin denuntare unilaterala cu preaviz de ${data.notificareZile || "30"} zile`);

  pdf.article("8.2.", "Comodantul poate cere restituirea imobilului inainte de termen daca Comodatarul nu respecta destinatia sau obligatiile contractuale.");
  pdf.article("8.3.", "In caz de nevoie urgenta si neprevazuta, Comodantul poate solicita restituirea imobilului inainte de termen, cu un preaviz rezonabil.");

  // IX. RASPUNDERE
  pdf.section("IX. RASPUNDERE");

  pdf.pMixed([
    { text: "9.1. ", bold: true },
    { text: "Comodatarul raspunde pentru orice deteriorare a imobilului cauzata din culpa sa sau a persoanelor carora le-a permis accesul." },
  ], { indent: 5 });

  pdf.pMixed([
    { text: "9.2. ", bold: true },
    { text: "Uzura normala rezultata din folosinta conform destinatiei nu constituie dauna." },
  ], { indent: 5 });

  pdf.pMixed([
    { text: "9.3. ", bold: true },
    { text: "Comodatarul raspunde pentru pieirea imobilului, daca aceasta se datoreaza folosirii necorespunzatoare sau daca ar fi putut salva imobilul inlocuindu-l cu propriul sau bun." },
  ], { indent: 5 });

  // X. FORTA MAJORA
  pdf.section("X. FORTA MAJORA");

  pdf.pMixed([
    { text: "10.1. ", bold: true },
    { text: "Forta majora exonereaza de raspundere partea care o invoca, in conditiile legii, daca este notificata celeilalte parti in termen rezonabil de la aparitia evenimentului." },
  ], { indent: 5 });

  pdf.pMixed([
    { text: "10.2. ", bold: true },
    { text: "Prin forta majora se intelege orice eveniment extern, imprevizibil, absolut invincibil si inevitabil, conform art. 1351 alin. (2) din Codul Civil." },
  ], { indent: 5 });

  // XI. LITIGII
  pdf.section("XI. LITIGII");

  pdf.pMixed([
    { text: "11.1. ", bold: true },
    { text: "Litigiile decurgand din executarea prezentului contract se solutioneaza pe cale amiabila, iar in caz contrar de catre instantele judecatoresti competente." },
  ], { indent: 5 });

  // XII. DISPOZITII FINALE
  pdf.section("XII. DISPOZITII FINALE");

  pdf.pMixed([
    { text: "12.1. ", bold: true },
    { text: "Prezentul contract poate constitui titlu executoriu numai in conditiile prevazute de lege." },
  ], { indent: 5 });

  pdf.pMixed([
    { text: "12.2. ", bold: true },
    { text: "Orice modificare a prezentului contract se face prin act aditional semnat de ambele parti." },
  ], { indent: 5 });

  pdf.pMixed([
    { text: "12.3. ", bold: true },
    { text: "Partile declara ca datele de identificare furnizate sunt reale si corespund actelor de identitate." },
  ], { indent: 5 });

  pdf.pMixed([
    { text: "12.4. ", bold: true },
    { text: "Contractul se incheie in 2 (doua) exemplare originale, cate unul pentru fiecare parte." },
  ], { indent: 5 });

  // Signatures
  const comodantName = pdf.getPartyNamePFPJ(data, "comodant", data.comodantPJ);
  const comodatarName = pdf.getPartyNamePFPJ(data, "comodatar", data.comodatarPJ);

  pdf.signatures(
    { role: "COMODANT", name: comodantName, date: today },
    { role: "COMODATAR", name: comodatarName, date: today },
  );

  pdf.save(filename);
}
